// Copyright 2025-2026 Florian Gallon. All Rights reserved.
import { Check } from 'lucide-react';

export default function Audience({ isFr }) {
  const items = isFr
    ? [
        'vendez sur les marchés',
        'proposez des retraits de commandes à domicile',
        'gérez des commandes venues d’Instagram ou de formulaires',
        'calculez aujourd’hui votre production dans des tableurs',
        'voulez un seul endroit pour les recettes, les commandes et la production',
      ]
    : [
        'sell at farmers markets',
        'offer pickup orders from home',
        'manage orders from Instagram or forms',
        'work out production in spreadsheets today',
        'want one place for recipes, orders and production',
      ];

  return (
    <section className="dbk-section dbk-section--line">
      <div className="dbk-wrap">
        <div className="dbk-head">
          <h2 className="dbk-h2">{isFr ? 'À qui ça s’adresse' : 'Who it’s for'}</h2>
          <p className="dbk-lede">
            {isFr
              ? 'Digi-Bakery est pensé pour les micro-boulangeries et les boulangers artisans (1 à 2 personnes) qui produisent 10 à 50 pains par semaine.'
              : 'Digi-Bakery is built for artisan micro-bakeries — one- or two-person operations baking 10 to 50 loaves a week.'}
          </p>
        </div>

        <div className="dbk-audience__box">
          <p className="dbk-audience__lead">{isFr ? 'Fait pour vous si vous :' : 'A good fit if you:'}</p>
          <ul className="dbk-checklist">
            {items.map((t) => (
              <li key={t}><Check size={16} strokeWidth={2.25} />{t}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
